// extracted by mini-css-extract-plugin
export default {"button":"ButtonLink_button__XR5jF","underline":"ButtonLink_underline__23lOE"};